import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-navy-950 text-center text-white" aria-label="Limited time offer" data-id="element-213" data-mp="2sk46nkhn1yb1">
      <div className="h-1 w-full bg-gold" aria-hidden="true" data-id="element-214" data-mp="36bio3mvwdrfz" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-215" data-mp="31iphsuks6b1s">
        <p className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[.16em] text-gold" data-id="element-216" data-mp="31hxvkad2ppo6">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-217" data-mp="3g9ygruakp8rl" /> Launch pricing ends in:
        </p>
        <Countdown className="mt-5" data-id="element-218" data-mp="3bbeq5gl1b8sw" />
        <p className="mt-7 font-bold text-steel-light" data-id="element-219" data-mp="3p93ewzi83038">After that the price increases and never drops again.</p>
      </div>
      <div className="h-1 w-full bg-gold" aria-hidden="true" data-id="element-220" data-mp="3l7q74jvkkmto" />
    </section>;
}